import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import moment from 'moment';
import getLocale from '../../i18n/getLocale';

class AvailabilitiesAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      contract_id: null,
      base_id: null,
      interruption_start: null,
      interruption_finish: null,
      deadline_preview: null,
      deadline_preview_delay: null,
      availability_time: null,
      availability_finish: null,
      availability: null,
      spare_time: null,
      type: null,
      abnormal_ocurrence: '0',
      reason: null,
      contracts_select: [],
      bases_select: [],
      aircrafts_select: [],
      aircrafts_select: [],
      types_select: [],
      errors_messages: [],
      errors_listing: false,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.handleChangeWithDelayCalc = this.handleChangeWithDelayCalc.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectContractChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    if (event.value === null || typeof event.value === 'undefined' || event.value === '') {
      this.setState(change);
      self.setState({ availability_time: null });
      self.setState({ availability_finish: null });
      self.setState({ availability: null });
      self.setState({ spare_time: null });
    } else {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/indisponibilidade/contrato/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ availability_time: responseJson.data.availability_time });
            self.setState({ availability_finish: responseJson.data.availability_finish });
            self.setState({ availability: responseJson.data.availability });
            self.setState({ spare_time: responseJson.data.spare_time });
          }
        });
      });
      this.setState(change);
    }
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleChangeWithDelayCalc(name, event) {
    var change = {};

    change[name] = event.target.value;

    if(this.state.deadline_preview && this.state.interruption_finish) {

      let deadline_preview = this.state.deadline_preview;
      let interruption_finish = this.state.interruption_finish;

      if (name === 'deadline_preview') {
        deadline_preview = event.target.value;
      } else {
        interruption_finish = event.target.value;
      }

      if(deadline_preview.length === 16 && interruption_finish.length === 16) {
        deadline_preview = moment(deadline_preview, "DD/MM/YYYY HH:mm:ss");
        interruption_finish = moment(interruption_finish, "DD/MM/YYYY HH:mm:ss");

        deadline_preview = new Date(deadline_preview.format("YYYY-MM-DD HH:mm:ss"));
        interruption_finish = new Date(interruption_finish.format("YYYY-MM-DD HH:mm:ss"));
        let diffTime = Math.abs(deadline_preview.getTime() - interruption_finish.getTime());
        if (interruption_finish > deadline_preview) {
          change['deadline_preview_delay'] = this.calcTimeFromMs(diffTime);
        } else {
          change['deadline_preview_delay'] = '00:00';
        }
      } else {
        change['deadline_preview_delay'] = '00:00';
      }
    } else {
      change['deadline_preview_delay'] = '00:00';
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }
  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  calcTimeFromMs(diffTime) {
    diffTime = diffTime/1000;
    var secs = diffTime % 60;
    diffTime = (diffTime - secs) / 60;
    var mins = diffTime % 60;
    var hrs = (diffTime - mins) / 60;
    if (secs < 10) { secs = '0' + secs; }
    if (mins < 10) { mins = '0' + mins; }
    if (hrs < 10) { hrs = '0' + hrs; }
    return hrs + ':' + mins + ':' + secs ;
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/indisponibilidade/info/cadastro';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({ contracts_select: responseJson.data.contracts_select });
          self.setState({ bases_select: responseJson.data.bases_select });
          self.setState({ aircrafts_select: responseJson.data.aircrafts_select });
          self.setState({ types_select: responseJson.data.types_select });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      });
    });
  }

  add(event) {
    event.preventDefault();
    var datasave = {
      contract_id: this.state.contract_id,
      base_id: this.state.base_id,
      interruption_start: this.state.interruption_start,
      interruption_finish: this.state.interruption_finish,
      abnormal_ocurrence: this.state.abnormal_ocurrence,
      reason: this.state.reason,
      deadline_preview: this.state.deadline_preview,
      deadline_preview_delay: this.state.deadline_preview_delay,
      type: this.state.type,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/indisponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/indisponibilidade/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
        } else if(responseJson.status === 'warning') {
          self.setState({
            errors_listing: true,
            errors_messages: responseJson.data,
          });
        } else {
          self.setState({
            errors_listing: false,
            errors_messages: [],
          });
        }
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Indisponibilidades.AdicionarIndisponibilidade.titulo}</h3>
      <Link to="/indisponibilidades" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      {this.state.errors_listing &&
        <div className="alert alert-danger alert-dismissible" role="alert" style={{marginTop: 25}}>
          <button onClick={() => self.setState({ errors_listing: false, errors_messages: [], })} type="button" className="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.erros}:</strong>
          {Object.keys(self.state.errors_messages).map(function(k) {
            var message = self.state.errors_messages[k];
            return (
              <p>- {message}</p>
            );
          })}
        </div>
      }
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.Contrato}:</label>
              <Select
                className="form-field-name"
                name="contract_id"
                value={this.state.contract_id}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.placeholder.SelecionarContrato}
                onChange={this.handleSelectContractChange.bind(this, 'contract_id')}
                options={this.state.contracts_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.InicioInterrupcao}:</label>
              <InputMask value={this.state.interruption_start} name="interruption_start" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'interruption_start')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.Base}:</label>
              <Select
                className="form-field-name"
                name="base_id"
                value={this.state.base_id}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.placeholder.SelecionarBase}
                onChange={this.handleSelectChange.bind(this, 'base_id')}
                options={this.state.bases_select}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.Tipo}:</label>
              <Select
                className="form-field-name"
                name="type"
                value={this.state.type}
                searchable={true}
                placeholder={this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.placeholder.SelecionarTipo}
                onChange={this.handleSelectChange.bind(this, 'type')}
                options={this.state.types_select}
                required
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.HoraInicialContratual}:</label>
              <input value={this.state.availability_time} name="availability_time" className="form-control" onChange={this.handleChange.bind(this, 'availability_time')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.HoraTerminoContratual}:</label>
              <input value={this.state.availability_finish} name="availability_finish" className="form-control" onChange={this.handleChange.bind(this, 'availability_finish')} placeholder="" disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.TempoDisponibilidadeContratual}:</label>
              <input value={this.state.availability} name="availability" className="form-control" onChange={this.handleChange.bind(this, 'availability')} placeholder="" disabled />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.Franquia}:</label>
              <input value={this.state.spare_time} name="spare_time" className="form-control" onChange={this.handleChange.bind(this, 'spare_time')} placeholder="" disabled />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.OcorrenciaAnormal}:</label>
              <Select
                className="form-field-name"
                name="abnormal_ocurrence"
                value={this.state.abnormal_ocurrence}
                searchable={true}
                placeholder={''}
                onChange={this.handleSelectChange.bind(this, 'abnormal_ocurrence')}
                options={[
                  {value: '0', label: this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.opcoesOcorrenciaAnormal.Nao},
                  {value: '1', label: this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.opcoesOcorrenciaAnormal.Sim},
                ]}
                required
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.Razao}:</label>
              <input value={this.state.reason} name="reason" className="form-control" onChange={this.handleChange.bind(this, 'reason')} placeholder="" required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.PrevisaoRetorno}:</label>
              <InputMask value={this.state.deadline_preview} name="deadline_preview" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'deadline_preview')} onBlur={this.handleChangeWithDelayCalc.bind(this, 'deadline_preview')} placeholder={this.locale.general.diaMesAnoHoraMinuto} required />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.FimInterrupcao}:</label>
              <InputMask value={this.state.interruption_finish} name="interruption_finish" mask="99/99/9999 99:99" className="form-control" onChange={this.handleChange.bind(this, 'interruption_finish')} onBlur={this.handleChangeWithDelayCalc.bind(this, 'interruption_finish')} placeholder={this.locale.general.diaMesAnoHoraMinuto} />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.DiferencaPrevisaoRetorno}:</label>
              <InputMask value={this.state.deadline_preview_delay} name="deadline_preview_delay" mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'deadline_preview_delay')} placeholder={this.locale.general.horaMinuto} />
            </div>
          </div>
        </div>
        <hr />
        <div className="form-group">
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Indisponibilidades.AdicionarIndisponibilidade.formulario.botaoAdicionarIndisponibilidade}</button>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default AvailabilitiesAdd;



// WEBPACK FOOTER //
// ./src/Components/Availabilities/AvailabilitiesAdd.js